import Gen1ReplacementModal from 'src/components/Modals/Gen1ReplacementModal.svelte';
import type { DiscountDetailsType } from 'src/types/DiscountType';
import { profile_data } from 'src/stores/account/user';
import { get } from 'svelte/store';
import { g1DHasValidExpiry } from 'src/helpers/home_helpers';
import { PROMOTIONS } from 'src/constants';

export const Gen1ReplacementConfig = (forceShow = false) => {
	const g1dItems = get(profile_data)?.aep?.g1d
		? Object.entries(get(profile_data).aep.g1d).map(([key, item]) => ({
				...(item as DiscountDetailsType),
				key,
			}))
		: [];

	return {
		id: 'gen1Replacement',
		component: Gen1ReplacementModal,
		props: {
			showModal: true,
			g1dItems,
		},
		rules: [
			{
				check: () => {
					const now = new Date().getTime();
					return (
						g1dItems.length > 0 &&
						g1DHasValidExpiry(g1dItems) &&
						// (g1dItems.filter((item) => !item.seen).length > 0 || forceShow) &&
						now >= PROMOTIONS.GEN_1_REPLACEMENT.START_DATE &&
						now <= PROMOTIONS.GEN_1_REPLACEMENT.END_DATE
					);
				},
				expected: true,
			},
		],
	};
};
